export class FilterModel {
  field: string;
  value: string;
  airportPk: number;
  isSelected: boolean = false;
  navaidsSelectedOnMapId?: string[];
  active: boolean = false;
  minAltitude?: number;
  maxAltitude?: number;
}
